import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { getSEOData } from '../utils/seoData';
import { CLINICAL_DISCLAIMER } from '../data/ewm';
import './Narrative.css';

function Terms() {
  return (
    <div className="np-page">
      <SEO {...getSEOData('terms')} />

      <section className="np-hero np-hero--compact">
        <div className="container">
          <h1>Terms of Use</h1>
          <p className="np-hero-sub">
            The terms that apply to your use of this website and its content.
          </p>
        </div>
      </section>

      <section className="np-section">
        <div className="container">
          <div className="np-disclaimer" style={{ maxWidth: '820px', margin: '0 auto 40px' }}>
            <strong>Not a medical device.</strong> {CLINICAL_DISCLAIMER}
          </div>

          <div className="np-prose">
            <p className="np-updated">Last updated: 18 September 2026</p>

            <h2>1. Acceptance</h2>
            <p>
              By accessing or using this website you agree to these terms. If you do not agree,
              please do not use the site.
            </p>

            <h2>2. Purpose of this website</h2>
            <p>
              This site describes our research, our technology and our products. Content is
              provided for general information. It is not an offer, a quotation, or a commitment to
              supply any product or service, and it does not create a contract between you and
              Codentic AI.
            </p>

            <h2>3. Research demonstrations and clinical content</h2>
            <p>
              Some features described on this site — including clinical report analysis and
              diagnostic matching — are research demonstrations provided for partner evaluation.
            </p>
            <ul>
              <li>They are not a medical device and have not been certified as one.</li>
              <li>They do not constitute medical advice.</li>
              <li>
                They must not be used as the sole basis for any clinical, diagnostic or treatment
                decision. Qualified professional review is always required.
              </li>
            </ul>

            <h2>4. Performance and measurements</h2>
            <p>
              Benchmark figures and proof-of-concept results published on this site are measured in
              our own proof-of-concepts, on the hosts and datasets named alongside them. They
              describe those specific runs. They are not a guarantee of performance on your data,
              your model or your infrastructure, and results will vary with the host, the
              vocabulary and the deployment.
            </p>

            <h2>5. Confidential materials</h2>
            <p>
              Documents we share with you outside this site — technical proposals and similar
              materials — are confidential. They are shared for evaluation purposes only, must not
              be redistributed or reproduced without our written consent, and remain subject to any
              additional terms communicated with them. Market-sizing figures in those materials are
              directional and are noted there as subject to validation.
            </p>

            <h2>6. Intellectual property and licensing</h2>
            <p>
              Unless stated otherwise, the text, design, graphics and code of this website are
              owned by Codentic AI and are protected by applicable intellectual property laws. You
              may view and print pages for your own internal evaluation.
            </p>
            <p>
              Our measurement layer and core crates are released under the MIT licence, which
              governs their use. Enterprise offerings, adapters, vertical packs, documentation and
              support are governed by separate commercial terms. Nothing on this website grants a
              licence to our trademarks or to any component not expressly released under an open
              licence.
            </p>

            <h2>7. Acceptable use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>use the site in breach of any applicable law or regulation;</li>
              <li>attempt to gain unauthorised access to any part of the site or its systems;</li>
              <li>
                scrape, harvest or bulk-extract content, or circumvent access controls on
                restricted materials;
              </li>
              <li>
                upload content you do not have the right to share, or any content that is unlawful
                or malicious.
              </li>
            </ul>

            <h2>8. Third-party links</h2>
            <p>
              This site may link to third-party sites. We do not control them and are not
              responsible for their content or practices.
            </p>

            <h2>9. No warranty</h2>
            <p>
              The site and its content are provided &ldquo;as is&rdquo; and &ldquo;as
              available&rdquo;, without warranties of any kind, express or implied, including
              fitness for a particular purpose or non-infringement. We do not warrant that the site
              will be uninterrupted, timely, secure or error-free.
            </p>

            <h2>10. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, Codentic AI shall not be liable for any
              indirect, incidental, special, consequential or punitive damages, or for any loss of
              profits, data or business opportunity, arising out of or in connection with your use
              of this site.
            </p>

            <h2>11. Changes to the site and these terms</h2>
            <p>
              We may modify the site and these terms at any time. Continued use of the site after a
              change constitutes acceptance of the revised terms.
            </p>

            <h2>12. Governing law</h2>
            <p>
              These terms are governed by the laws of India, and the courts of India shall have
              exclusive jurisdiction over any dispute arising from them.
            </p>

            <h2>13. Contact</h2>
            <p>
              Questions about these terms can be sent to{' '}
              <a href="mailto:support@codenticai.com">support@codenticai.com</a>. See also our{' '}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Terms;
